<template>
  <tr v-if="slotHasValue" :class="['key-value-table-row', { 'key-value-table-row--single-value': !label }]">
    <td v-if="label" v-epi-edit="(epiEdit && label) && label">
      {{ label }}
    </td>

    <td>
      {{ value }}

      <slot></slot>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    epiEdit: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    }
  },
  computed: {
    slotHasValue() {
      return (this.value || this.$slots.default !== undefined)
    }
  }
}
</script>

<style lang="scss" scoped>
.key-value-table-row {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(quarter);

  @include media(small) {
    display: table-row;
    margin-bottom: 0;
  }
}

.key-value-table-row td {
  padding-bottom: measure(eighth);
  vertical-align: middle;

  &:nth-child(1) {
    @include body-semi-bold;
  }

  @include media(to-small) {
    &:nth-child(2) {
      padding-bottom: 0;
    }
  }

  @include media(small) {
    padding-bottom: measure(quarter);

    &:nth-child(2) {
      padding-left: measure(full);
      text-align: right;
    }
  }
}

.key-value-table-row--single-value td {
  &:first-child {
    @include body;
    text-align: left;
  }
}

.key-value-table-row:last-child td {
  padding-bottom: 0;
}
</style>
